<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">数据中心</span>
      </div>
    </div>
    <div class="top1">
      <div class="t1left">
        <p class="title"
           style="color:#0B8586">数据中心</p>
        <div class="t1lbox"
             style="padding-bottom:20px;padding-left:16px;padding-right:16px;">
          <div class="t1rboxs"
               style="width:444px"
               ref="t1l"></div>
          <div class="t1ltitle">
            <p>{{liulanNum}}</p>
            <span>浏览量</span>
          </div>
        </div>
      </div>
      <div class="t1right">
        <p class="title"
           style="color:#C32424;border-color:#C32424;">粉丝中心</p>
        <div class="t1rbox">
          <div class="t1rboxs"
               ref="t1r"></div>
          <div class="t1ltitle">
            <p>{{fensiNum}}</p>
            <span>粉丝量</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="title top2title">
        <span>数据趋势图</span>
        <div class="t2tright"
             @click="ist2trbox=!ist2trbox">
          <span>{{top2typeName}}</span>
          <img src="../../assets/img/organ/xia1.png"
               v-show="!ist2trbox"
               alt="">
          <img src="../../assets/img/organ/shang1.png"
               v-show="ist2trbox"
               alt="">
          <div class="t2trbox"
               v-show="ist2trbox">
            <p @click="top2typeName='最近七天';top2typeId=1"
               style="border-bottom: 1px solid #0b8586;">最近七天</p>
            <p @click="top2typeName='最近一年';top2typeId=2">最近一年 </p>
          </div>
        </div>
      </div>
      <div class="top2"
           ref="top2"></div>
    </div>
    <div>
      <p class="title"
         style="color:#C32424;border-color:#C32424;">粉丝分布图</p>
      <div class="box"
           v-if="isfans">
        <div class="boxs">
          <p class="bsTitle">学历分布图</p>
          <div class="bsBox"
               ref="box1"></div>
        </div>
        <div class="boxs">
          <p class="bsTitle">职称分布图</p>
          <div class="bsBox"
               ref="box2"></div>
        </div>
        <div class="boxs">
          <p class="bsTitle">科室分布图</p>
          <div class="bsBox"
               ref="box3"></div>
        </div>
        <div class="boxs">
          <p class="bsTitle">内容标签分布图</p>
          <div class="bsBox"
               ref="box4"></div>
        </div>
      </div>
      <div v-else
           style="width:100%;text-align: center;height:100px;padding:45px">
        <span>暂无数据</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  data () {
    return {
      storeList: [],
      myChart: '',
      isfans: false,
      myChart2: '',
      top2typeName: '最近七天',
      top2typeId: 1,
      ist2trbox: false,
      liulanNum: 0,
      fensiNum: 0
    };
  },
  created () {
    this.GetExpertsInfo()
    this.getFansChart()
  },
  mounted () {
    this.getTop1Chart()
    this.getTop2Chart()
    this.getT1rChart()
    this.getT1lChart()
  },
  watch: {
    top2typeName: function () {
      this.getTop2Chart()
    }
  },
  methods: {
    GetExpertsInfo () {
      this.httphelper
        .post('/api/CGPExpertApi/GetExpertInfoContent', {
          ExpertId: Number(localStorage.getItem('storeId')),
          UserId: 0
        })
        .then(res => {
          if (res.data.code == 200) {
            this.fensiNum = res.data.data.fans
            this.liulanNum = res.data.data.pageview
          }
        });
    },
    getFansChart () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertFansStatis', {
        ExpertId: Number(localStorage.getItem('storeId')),
        // ExpertId: 40,
      }).then(res => {
        if (res.code == 200) {
          if (res.data.edlist.length > 0) {
            this.isfans = true
          }
        }
      });
    },
    getTop1Chart () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertFansStatis', {
        ExpertId: Number(localStorage.getItem('storeId')),
        // ExpertId: 40,
      }).then(res => {
        if (res.code == 200) {
          this.myChart = res.data
          if (res.data.edlist.length > 0) {
            // 基于准备好的dom，初始化echarts实例
            var myChart1 = echarts.init(this.$refs.box1);
            var myChart2 = echarts.init(this.$refs.box2);
            var myChart3 = echarts.init(this.$refs.box3);
            var myChart4 = echarts.init(this.$refs.box4);
            // 绘制图表
            myChart1.setOption({
              tooltip: {
                trigger: 'item'
              },
              legend: {
                top: '120',
                left: 'center',
                itemWidth: 8,
                itemHeight: 8,
                padding: 1,
                itemGap: 7,
                textStyle: {
                  fontWeight: 400,
                  fontFamily: 'Microsoft YaHei',
                  fontSize: 12
                }
              },
              series: [
                {
                  top: '-15',
                  height: '143',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  avoidLabelOverlap: false,
                  itemStyle: {
                    borderRadius: 1,
                    borderColor: '#fff',
                    borderWidth: 2
                  },
                  label: {
                    show: false,
                    position: 'center'
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: '10',
                      fontWeight: 'bold'
                    }
                  },
                  labelLine: {
                    show: false
                  },
                  data: this.myChart.edlist
                }
              ]
            });
            myChart2.setOption({
              tooltip: {
                trigger: 'item'
              },
              legend: {
                top: '120',
                left: 'center',
                itemWidth: 8,
                itemHeight: 8,
                padding: 1,
                itemGap: 7,
                textStyle: {
                  fontWeight: 400,
                  fontFamily: 'Microsoft YaHei',
                  fontSize: 12
                }
              },
              series: [
                {
                  top: '-15',
                  height: '143',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  avoidLabelOverlap: false,
                  itemStyle: {
                    borderRadius: 1,
                    borderColor: '#fff',
                    borderWidth: 2
                  },
                  label: {
                    show: false,
                    position: 'center'
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: '10',
                      fontWeight: 'bold'
                    }
                  },
                  labelLine: {
                    show: false
                  },
                  data: this.myChart.prolist
                }
              ]
            });
            myChart3.setOption({
              tooltip: {
                trigger: 'item'
              },
              legend: {
                top: '120',
                left: 'center',
                itemWidth: 8,
                itemHeight: 8,
                padding: 1,
                itemGap: 7,
                textStyle: {
                  fontWeight: 400,
                  fontFamily: 'Microsoft YaHei',
                  fontSize: 12
                }
              },
              series: [
                {
                  top: '-15',
                  height: '143',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  avoidLabelOverlap: false,
                  itemStyle: {
                    borderRadius: 1,
                    borderColor: '#fff',
                    borderWidth: 2
                  },
                  label: {
                    show: false,
                    position: 'center'
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: '10',
                      fontWeight: 'bold'
                    }
                  },
                  labelLine: {
                    show: false
                  },
                  data: this.myChart.admlist
                }
              ]
            });
            myChart4.setOption({
              tooltip: {
                trigger: 'item'
              },
              legend: {
                top: '120',
                left: 'center',
                itemWidth: 8,
                itemHeight: 8,
                padding: 1,
                itemGap: 7,
                textStyle: {
                  fontWeight: 400,
                  fontFamily: 'Microsoft YaHei',
                  fontSize: 12,
                  lineHeight: 5
                }
              },
              series: [
                {
                  // name: '未知',
                  top: '-15',
                  height: '143',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  avoidLabelOverlap: false,
                  itemStyle: {
                    borderRadius: 1,
                    borderColor: '#fff',
                    borderWidth: 2
                  },
                  label: {
                    show: false,
                    position: 'center'
                  },
                  emphasis: {
                    label: {
                      show: true,
                      fontSize: '10',
                      fontWeight: 'bold'
                    }
                  },
                  labelLine: {
                    show: false
                  },
                  data: this.myChart.lablist
                }
              ]
            });
          }
        }
      });
    },
    getTop2Chart () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertDataStatis', {
        ExpertId: Number(localStorage.getItem('storeId')),
        Type: this.top2typeId
      }).then(res => {
        if (res.code == 200) {
          this.myChart2 = res.data
          let arr = [['product', '收藏量', '订阅量', '评论量', '点击量', '播放量'],]
          for (let i = 0; i < res.data.length; i++) {
            arr.push([
              res.data[i].name,
              res.data[i].collcet,
              res.data[i].fans,
              res.data[i].comment,
              res.data[i].click,
              res.data[i].integer,
            ])
          }
          echarts.init(this.$refs.top2).setOption({
            legend: {
              top: 280
            },
            grid: {
              left: '40px',
              right: '0px',
              top: '30px'
            },
            tooltip: {},
            dataset: {
              source: arr
            },
            xAxis: { type: 'category' },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [

              { barWidth: 8, type: 'bar' },
              { barWidth: 8, type: 'bar' },
              { barWidth: 8, type: 'bar' },
              { barWidth: 8, type: 'bar' },
              { barWidth: 8, type: 'bar' },
              //   { barWidth: 4, type: 'bar' },
              //   { barWidth: 4, type: 'bar' },
              //   { barWidth: 4, type: 'bar' }
            ]
          });
        }
      })
    },
    getT1rChart () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertDataStatis', {
        ExpertId: Number(localStorage.getItem('storeId')),
        Type: 1
      }).then(res => {
        if (res.code == 200) {
          let arr1 = []
          let arr2 = []
          let arr3 = []
          for (let i = 0; i < res.data.length; i++) {
            arr1.push(res.data[i].name)
            arr2.push(res.data[i].fans)
            arr3.push(res.data[i].comment)
          }
          echarts.init(this.$refs.t1r).setOption({
            legend: {},
            grid: {
              left: '-1px',
              right: '0px',
              top: '10px',
              bottom: '10px'
            },
            color: ['#00f', '#0ff'],
            xAxis: {
              boundaryGap: false,
              show: false,
              data: arr1
            },
            yAxis: {
              splitLine: {
                show: false
              },
            },
            series: [{
              type: 'line',
              smooth: true,
              symbol: 'none',
              areaStyle: { //区域填充样式
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(255, 0, 212, 0.5)'
                  }, {
                    offset: 1,
                    color: 'rgba(255, 136, 212, 0)'
                  }], false),
                  shadowColor: 'rgba(0, 0, 0, 0.4)',
                  shadowBlur: 10
                }
              },
              lineStyle: {
                color: '#2F4554',
              },
              data: arr2
            }, {
              type: 'line',
              smooth: true,
              symbol: 'none',
              areaStyle: { //区域填充样式
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: 'rgba(0, 236, 255, 0.5)'
                  }, {
                    offset: 1,
                    color: 'rgba(0, 136, 212, 0)'
                  }], false),
                  shadowColor: 'rgba(0, 0, 0, 0.4)',
                  shadowBlur: 10
                }
              },
              lineStyle: {
                color: '#6AB0B8',
              },
              data: arr3
            }]
          });
        }
      })
    },
    getT1lChart () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertDataStatis', {
        ExpertId: Number(localStorage.getItem('storeId')),
        Type: 1
      }).then(res => {
        if (res.code == 200) {
          let arr1 = []
          let arr2 = []
          let arr3 = []
          for (let i = 0; i < res.data.length; i++) {
            arr1.push(res.data[i].name)
            arr2.push(res.data[i].click)
            arr3.push(res.data[i].integer)
          }
          echarts.init(this.$refs.t1l).setOption({
            tooltip: {
              trigger: 'axis'
            },
            legend: {},
            grid: {
              left: '-20px',
              right: '-20px',
              top: '6px',
              bottom: '1px'
            },
            xAxis: {
              type: 'category',
              data: arr1,
              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              }
            },
            yAxis: {
              splitLine: {
                show: false
              },
            },
            series: [{
              type: 'line',
              data: arr2,
              color: "#D48265",
              lineStyle: {
                color: '#D48265',
                normal: {
                  width: 3,
                  color: {
                    type: 'linear',

                    colorStops: [{
                      offset: 1,
                      color: '#D48265' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: '#F58080',
                  borderWidth: 3,
                  borderColor: "#F58080"
                }
              },
              smooth: true
            }, {
              type: 'line',
              data: arr3,
              color: "#91C7AE",
              lineStyle: {
                color: '#91C7AE',
                normal: {
                  width: 3,
                  color: {
                    type: 'linear',

                    colorStops: [{
                      offset: 1,
                      color: '#91C7AE' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  },
                }
              },
              itemStyle: {
                normal: {
                  color: '#AAF487',
                  borderWidth: 3,
                  borderColor: "#AAF487"
                }
              },
              smooth: true
            }]
          });
        }
      })
    }
  }
};
</script>

<style scoped>
.title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 18px;
    padding-left: 14px;
    border-left: 2px solid #0b8586;
    margin-top: 40px;
}
.box {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}
.boxs {
    width: 143px;
    height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.boxs .bsTitle {
    height: 40px;
    line-height: 40px;
}
.boxs .bsBox {
    width: 143px;
    height: 193px;
}
.top1 {
    display: flex;
    justify-content: space-between;
}
.t1left,
.t1right {
    width: 476px;
}
.t1lbox,
.t1rbox {
    height: 190px;
    margin-top: 15px;
    background: #f3f5f8;
    padding: 80px 30px 10px;
    box-sizing: border-box;
    position: relative;
}
.t1rboxs {
    width: 416px;
    height: 100%;
}
.t1ltitle {
    position: absolute;
    top: 26px;
    left: 30px;
}
.t1ltitle p {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.t1ltitle span {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #8d909d;
    margin-top: 2px;
}
.top2 {
    height: 300px;
    margin-top: 15px;
}
.top2title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.t2tright {
    width: 89px;
    height: 21px;
    background: #0b8586;
    border-radius: 2px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    line-height: 12px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
}
.t2tright img {
    width: 9px;
    height: 6px;
}
.t2trbox {
    width: 89px;
    height: 40px;
    border: 1px solid #0b8586;
    box-sizing: border-box;
    position: absolute;
    top: 20px;
    left: 0;
    z-index: 100;
    background-color: #fff;
}
.t2trbox p {
    height: 18px;
    line-height: 18px;
    padding: 0 10px;
    color: #0b8586;
}
</style>